import { useEffect, useState } from "react";
import { Form, Button, InputNumber } from "antd";
import { showSuccess, showError } from "infra/helpers/alerta";
import { useOperacaoOrdemServicoTalhoes } from "../../../hooks/useGetHistoricoPlanejamentoOperacao";
import useModal from "../../../hooks/useModalPlanejamentoOperacoes";
import { SelectAntd, CustomModal, Textarea, RowWrapper, ContentWrapperInput, ButtonSend } from "./styles";
import { MdEditNote } from "react-icons/md";
import { dateModified, formatarDataBR } from "./utils";
import URL from 'core/resources/urls';
import { useQueryClient } from "react-query";
import { useFilters } from "core/features/filters/store";

interface ModalCancelarOperacaoProps {
  refetch: () => void;
}

const { Item, useForm } = Form;

function ModalAnteciparOuProrrogar({ refetch }: ModalCancelarOperacaoProps) {
  const { mutateAsync: update, isLoading } = useOperacaoOrdemServicoTalhoes();
  const { setIds, isAnteciparOuProrrogarModal, setIsAnteciparOuProrrogarModal, anteciparOuProrrogar, setAnteciparOuProrrogar, planoOperacionalOperacaoTalhao, setPlanoOperacionalOperacaoTalhao, talhaoId } = useModal();
  const [form] = useForm();
  const {filters: { filtersAdvanced}} = useFilters();
  const queryClient = useQueryClient();
  const [dataString, setDataString] = useState(anteciparOuProrrogar.data ?? '');
  const [numberQtde, setNumberQtde] = useState(0);

  function closedModal() {
    setIsAnteciparOuProrrogarModal(false);
    setIds([]);
    setAnteciparOuProrrogar({
      name: "",
      data: ""
    })
    setPlanoOperacionalOperacaoTalhao(null);
    form.resetFields();
  }

  useEffect(() => {
    if (anteciparOuProrrogar.data) {
      setDataString(formatarDataBR(anteciparOuProrrogar.data));
    }
  }, [anteciparOuProrrogar.data]);

  useEffect(() => {
    setNumberQtde(0);
  }, [isAnteciparOuProrrogarModal])

  async function onFinish() {
    const message = anteciparOuProrrogar.name === "Prorrogar" ? "prorrogada" : "antecipada";
     try {
      const id = planoOperacionalOperacaoTalhao?.planoOperacionalOperacaoTalhaoId;
      const type = anteciparOuProrrogar.name === "Prorrogar" ? 2 : 1;
      const payload = {
        ...form.getFieldsValue(),
        tipoAlteracao: type,
        planoOperacionalOperacaoTalhaoIds: [id]
      }

      const response = await update({  body: payload });

      if (response.status === 204) {
        showSuccess(`Operação ${message} com sucesso!`);
        queryClient.invalidateQueries([URL.PLANO_OPERACIONAL.OBTER_LISTA_POR_TALHAO,talhaoId, { safraPeriodoId: filtersAdvanced.safraPeriodo }]);
        queryClient.invalidateQueries([URL.PLANO_OPERACIONAL.OBTER_HISTORICO_TALHAO_ORDEM_SERVICO, talhaoId]);
        refetch();
        closedModal();
        return;
      }
      const details = (response as any).response.data.Details;
      const error = details[0].Errors[0];
      showError(error);
    } catch (error) {
      showError(`Não foi possivel ${message} Operação`);
    }
  }

  const listMotivos = [
    {label: "Selecione um motivo", value: ""},
    {label: "Climático", value: 0},
    {label: "Decisão Agronômica", value: 1},
    {label: "Problema Operacional", value: 2},
    {label: "Capacidade Operacional", value: 3},
  ];

  const opt = anteciparOuProrrogar.name === "Prorrogar" ? "depois" : "antes";
  const dateCurrent = dataString === formatarDataBR(anteciparOuProrrogar.data) ? `(data atual)` : `(${numberQtde} dias ${opt})`;
  const colorTheme = anteciparOuProrrogar.name === "Prorrogar" ? "#f39c12" : "#27ae60";

  return (
    <CustomModal
      title={
        <span style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <MdEditNote size={24} />
          {anteciparOuProrrogar.name} Operação
        </span>
      }
      backgroundColor={colorTheme}
      visible={isAnteciparOuProrrogarModal}
      onCancel={closedModal}
      destroyOnClose
      maskClosable={false}
      className="teste"
      footer={
        <>
          <Button
            size="large"
            loading={isLoading}
            onClick={closedModal}
            style={{ borderRadius: 8 }}
          >Cancelar</Button>
          <ButtonSend
            size="large"
            type="primary"
            loading={isLoading}
            onClick={() => form.submit()}
            disabled={numberQtde === 0}
            backgroundColor={colorTheme}
          >Confirmar</ButtonSend>
        </>
      }
    >
      <div>
        <Form
            form={form}
            layout="vertical"
            onFinish={onFinish}
            initialValues={
              {
                reagendamentoQuantidadeDias: 1,
              }
            }
        >
          <RowWrapper>
            <Item
                label="Quantidade de dias"
                name="reagendamentoQuantidadeDias"
                rules={[{ required: true, message: "Campo quantidade é obrigatório" }]}
                className="qtde-dias"
                >
                  <ContentWrapperInput color={anteciparOuProrrogar.name === "Antecipar" ? "#00b894": "#fdcb6e"}>

                    <InputNumber
                        placeholder="Ex: 7"
                        type="number"
                        min={0}
                        value={numberQtde}
                        onChange={(value) => {
                          if (value === null) {
                            setDataString(formatarDataBR(anteciparOuProrrogar.data));
                            return;
                          }
                          const isAddDaysFormat = anteciparOuProrrogar.name === "Prorrogar";
                          const d = dateModified(anteciparOuProrrogar.data, value, isAddDaysFormat);
                          setDataString(d);
                          setNumberQtde(value);
                          form.setFieldsValue({
                            reagendamentoQuantidadeDias: value,
                          });
                        }}
                        max={365}
                    />
                    <span>
                      dias para {anteciparOuProrrogar.name.toLowerCase()}
                    </span>
                  </ContentWrapperInput>
              </Item>
              <span>A data será calculada automaticamente: {dataString} {dateCurrent}</span>
          </RowWrapper>
            <Item
                label="Motivo"
                name="motivo"
                rules={[{ required: true, message: "Campo Motivo é obrigatório" }]}
            >
            <SelectAntd
                options={listMotivos.map((item: any) => ({
                    label: item.label,
                    value: item.value,
                }))}
                />
            </Item>
            <Item
                label="Observação"
                name="observacao"
                rules={[{ required: true, message: "Campo Observação é obrigatório" }]}
                >
                <Textarea
                    placeholder="Descreva os detalhes da justificativa..."
                    maxLength={200}
                ></Textarea>
                </Item>
            </Form>
      </div>
    </CustomModal>
  );
}

export default ModalAnteciparOuProrrogar;
